import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import welcomeImg from "../../assests/images/welcomeImg.svg";
import LoginService from "../../services/auth/Login";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const VerifyEmailComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { encryptedUsername, encryptedAdminUsername } = useParams();

  useEffect(() => {
    let isCancelled = false;

    if (!encryptedUsername) {
      toast.error(t("invalid_verification_link"));
      navigate("/login");
      return;
    }

    LoginService.verifyEmail(encryptedUsername, encryptedAdminUsername)
      .then((res) => {
        if (isCancelled) return; 

        if (res.data.status) {
          toast.success(t(res?.data.data));
          navigate("/login");
        } else {
          toast.error(t(res?.data.message || "verification_failed"));
        }
      })
      .catch((error) => {
        if (isCancelled) return;
        toast.error(t("verification_error"));
        console.error("Error verifying email:", error);
      })
      .finally(() => {
        if (!isCancelled) {
          setLoading(false);
        }
      });

    return () => {
      isCancelled = true;
    };
  }, [encryptedUsername, navigate, t]);

  return (
    <>
      <section className="loginSection">
        <div className="container centerDiv">
          <div className="loginBgImg"></div>
          <div className="loginBg">
            <div className="row"></div>
            <div className="col-md-6 logincredDetail">
              <div className="loginFormSec login_left_section">
                <div className="loginLogo">
                  {/* <img src={company?.logo} alt="" /> */}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="welcomeImgSec">
                <div className="welcomHeadSec">
                  <h2>Welcome</h2>
                  <p>Your account has been verified</p>
                </div>
                <div className="welcomeImg">
                  <img src={welcomeImg} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VerifyEmailComponent;
